export default __webpack_public_path__ + "static/media/icon_menuarrowup_disabled.65c4a079.png";